
import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { Auth } from '@/models/auth';
import authService from '@/services/auth-services';

@Component({
    components: {
        Loading,
    },
})
export default class Login extends Vue {
    private isLoading = false;
    private userName = '';
    private password = '';
    constructor() {
        super();
    }

    private async submit() {
        const isValid = await (this.$refs['observer'] as any).validate();

        if (isValid && !this.isLoading) {
            this.isLoading = true;
            const dataRequest: Auth = {
                username: this.userName.toLowerCase(),
                password: this.password,
            };

            const result  = await authService.login(dataRequest);
            this.isLoading = false;
            if (result && result.status === 200 && result.data.user) {
                if (result.data.user.is_verified === true) {
                    Vue.notify({
                        group: 'foo',
                        type: 'success',
                        title: 'Thông báo!',
                        text: 'Bạn đã đăng nhập thành công!',
                    });
                    (window['getApp'] as any).$emit('APP_LOGIN_SUCCESS', result.data);
                } else {
                    (window['getApp'] as any).$emit('APP_REGISTER_SUCCESS', '/');
                }
            } else {
                 Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: 'Tên tài khoản hoặc mật khẩu không chính xác!',
                });
            }
        }
    }
}
